export const getPercentage = (current: number, previous?: number, fractionDigits = 2) => {
  if (current === 0 || (previous && previous === 0)) return "0%";

  const percentage = previous ? current / previous : current;
  if (isNaN(percentage)) return "0%";
  return Number(percentage).toLocaleString(undefined, {
    style: "percent",
    minimumFractionDigits: fractionDigits,
  });
};

export function getPercentageNumeric(current: number, previous?: number) {
  if (current === 0 || (previous && previous === 0)) return 0;
  const percentage = previous ? current / previous : current;
  if (isNaN(percentage)) return 0;
  return Number(percentage);
}

export function stringifyPercentage(number: number, fractionDigits = 2) {
  return number.toLocaleString(undefined, {
    style: "percent",
    minimumFractionDigits: fractionDigits,
  });
}
